export const Testing = (flujax) => ({
  exception (params) {
    const path = params ? `/testing/exception${params}` : '/testing/exception'
    return flujax.get(path)
  }
})
